
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/costa-brava/[region]",
      function () {
        return require("private-next-pages/costa-brava/[region].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/costa-brava/[region]"])
      });
    }
  